import { APIClient } from './api_helper';
import * as url from './url_helper';

const api = new APIClient();

// Login Method
export const postJwtLogin = (data, headers) => api.create(url.POST_LOGIN, data, headers);

export const getUsers = () => api.get(url.GET_USERS);
export const getSolutions = () => api.get(url.GET_SOLUTIONS);
export const getAnnouncement = () => api.get(url.GET_ANNOUNCEMENT);

export const createAnnouncement = (data, headers) => api.create(url.GET_ANNOUNCEMENT, data, headers);
export const getCategories = () => api.get(url.GET_CATEGORIES);
// export const createCategory = (data , headers) => api.create(url.GET_CATEGORIES,data,headers);
// export const deleteCategory = (id, headers) =>
//   api.create(`${url.DELETE_CATEGORY}/${id}`, {}, headers);

// export const updateCategory = (id, data, headers) => {
//   return api.create(`${url.UPDATE_CATEGORY}/${id}`, data, headers);
// }
export const createSolution = (id, data, headers) => {
  return api.create(`${url.CREATE_SOLUTION}/${id}`, data, headers);
};

export const createUser = (data, headers) => api.create(url.CREATE_USER, data, headers);

export const deleteUser = (id, headers) => api.create(`${url.DELETE_USER}/${id}`, {}, headers);

export const updateUser = (id, data, headers) => {
  return api.create(`${url.UPDATE_USER}/${id}`, data, headers);
};

export const uploadFile = (data, headers) => api.create(url.UPLOAD_FILE, data, headers);
export const deleteUploads = (data, headers) => api.create(url.DELETE_UPLOADS, data, headers);

export const deleteSolution = (id, headers) => api.create(`${url.DELETE_SOLUTION}/${id}`, {}, headers);

export const updateSolution = (id, data, headers) => {
  return api.update(`${url.CREATE_SOLUTION}/${id}`, data, headers);
};

export const getBanner = () => api.get(url.GET_BANNER);
export const createBanner = (data, headers) => api.create(url.GET_BANNER, data, headers);

// ===================================================================================

export const updateProcessBookingsCron = (isFuture) => api.get(`${url.UPDATE_BOOKINGS_CRON}?isFuture=${isFuture}`);
export const getBookings = (data) => api.create(url.GET_BOOKINGS, data);
export const getBookingsSettings = () => api.get(url.GET_BOOKINGS_SETTINGS);

export const updatPhoneNumerKross = (id, data) => {
  return api.update(`${url.UPDATE_PHONE_NUMBER_KROSS}/${id}`, data);
};

export const getShellyDevices = () => api.get(url.GET_SHELLY_DEVICES);
export const updateShellyDevices = () => api.get(url.UPDATE_SHELLY_DEVICES);

export const getBnbList = () => api.get(url.GET_BNBLIST);
export const createBnbList = (headers) => api.create(url.GET_BNBLIST, {}, headers);

export const getDoorsByBnBArray = (data) => api.create(url.GET_DOORLIST_BY_BNB, data);

export const createBnBList = (data, headers) => api.create(url.GET_BNBLIST, data, headers);

export const updateBnbList = (id, data, headers) => {
  return api.create(`${url.GET_BNBLIST}/${id}`, data, headers);
};
export const updateCleaningCost = (id, data, headers) => {
  return api.create(`${url.GET_CEALNING_COST}/${id}`, data, headers);
};

export const getDoorList = () => api.get(url.GET_DOORLIST);

export const createDoorList = (data, headers) => api.create(url.CREATE_DOORLIST, data, headers);

export const updateDoorlist = (id, data, headers) => {
  return api.create(`${url.UPDATE_DOORLIST}/${id}`, data, headers);
};
export const deleteDoor = (id, headers) => api.create(`${url.DEL_DOORLIST}/${id}`, {}, headers);

export const getContactInfo = () => api.get(url.CONTACTINFO);

export const createContactInfo = (data, headers) => api.create(url.CONTACTINFO, data, headers);

export const getCleanerSetting = () => api.get(url.CLEANER_SETTING);

export const createCleanerSetting = (data, headers) => api.create(url.CLEANER_SETTING, data, headers);

export const getAllQuestions = () => api.get(url.QUESTIONS);

export const createQuestion = (data, headers) => api.create(url.QUESTIONS, data, headers);
export const deleteQuestion = (id, headers) => api.create(`${url.DEL_QUESTIONS}/${id}`, {}, headers);

export const updateQuestion = (id, data, headers) => {
  return api.create(`${url.UPDATE_QUESTIONS}/${id}`, data, headers);
};

export const getAllAuthToken = () => api.get(url.AUTH_TOKEN);
export const updateAuthToken = (data, headers) => api.create(url.AUTH_TOKEN, data, headers);

export const getAllSpecialAcess = () => api.get(url.SPECIAL_ACCESSS);
export const createSpecialAccesss = (data, headers) => api.create(url.SPECIAL_ACCESSS, data, headers);
export const deleteSpecialAccess = (id, headers) => api.create(`${url.SPECIAL_ACCESS_DELETE}/${id}`, {}, headers);

export const updateSpecialAccess = (id, data, headers) => {
  return api.create(`${url.SPECIAL_ACCESS_UPDATE}/${id}`, data, headers);
};

export const getAllTravelGuide = () => api.get(url.TRAVEL_GUIDE);
export const deleteTravelGuide = (id, headers) => api.create(`${url.TRAVEL_GUIDE}/${id}`, {}, headers);

export const addTravelGuide = (data, headers) => api.create(url.TRAVEL_GUIDE, data, headers);
export const updateTravelGuide = (id, data, headers) => {
  return api.create(`${url.UPDATE_TRAVEL_GUIDE}/${id}`, data, headers);
};

export const getAllCity = () => api.get(url.CITY);

export const deleteCity = (id, headers) => api.create(`${url.DELETE_CITY}/${id}`, {}, headers);

export const createCity = (data, headers) => api.create(url.CITY, data, headers);

export const updateCity = (id, data, headers) => {
  return api.create(`${url.UPDATE_CITY}/${id}`, data, headers);
};

export const getAllCategory = () => api.get(url.CATEGORY);
export const createCategory = (data, headers) => api.create(url.CATEGORY, data, headers);
export const deleteCategory = (id, headers) => api.create(`${url.DELETE_CATEGORY}/${id}`, {}, headers);
export const updateCategory = (id, data, headers) => {
  return api.create(`${url.UPDATE_CATEGORY}/${id}`, data, headers);
};

export const getCategoriesOfCity = (city) => api.get(`${url.GET_CATEGORIES_OF_CITY}/${city}?isFromAdmin=1`);

export const getAllAssignCity = () => api.get(url.AssignCity);
export const deleteAssignCity = (id, headers) => api.create(`${url.DELETE_ASSIGN_CITY}/${id}`, {}, headers);

export const createAssignCity = (data, headers) => api.create(url.AssignCity, data, headers);
export const updateAssignCity = (id, data, headers) => {
  return api.create(`${url.UPDATE_ASSIGN_CITY}/${id}`, data, headers);
};

export const refreshCities = () => api.get(url.REFRESH_CITIES);

export const getBnBCities = () => api.get(url.getBnBCities);

export const getMaintance = () => api.get(url.CREATE_MAINTANCE);
export const updateMaintance = (id, headers) => api.create(`${url.UPDATE_MAINTANCE}/${id}`, {}, headers);

export const getRefillRequest = () => api.get(url.REFILL_REQUEST);
export const updateRefillRequest = (id, headers) => api.create(`${url.UPDATE_REFILL_REQUEST}/${id}`, {}, headers);

export const getExtraCleaningRequest = () => api.get(url.EXTRA_CLEANING_REQUEST);
export const updateExtraCleaningRequest = (id, headers) =>
  api.create(`${url.UPDATE_EXTRA_CLEANING_REQUEST}/${id}`, {}, headers);
export const getExtraCleaningSettings = () => api.get(url.UPDATE_EXTRA_CLEANING_SETTINGS);

export const updateExtraCleaningSettings = (data, headers) =>
  api.create(url.UPDATE_EXTRA_CLEANING_SETTINGS, data, headers);

export const getAllTexi = () => api.get(url.TEXI);
export const createTexi = (data, headers) => api.create(url.TEXI, data, headers);

export const updateTexi = (id, data, headers) => {
  return api.create(`${url.UPDATE_TEXI}/${id}`, data, headers);
};

export const deleteTexi = (id, headers) => api.create(`${url.DELETE_TEXI}/${id}`, {}, headers);

export const getAllAroundUs = () => api.get(url.AROUNDUS);
export const createAroundUs = (data, headers) => api.create(url.AROUNDUS, data, headers);

export const updateAroundUs = (id, data, headers) => {
  return api.create(`${url.UPDATE_AROUNDUS}/${id}`, data, headers);
};

export const deleteAroundUs = (id, headers) => api.create(`${url.DELETE_AROUNDUS}/${id}`, {}, headers);

export const getAllRefill = () => api.get(url.REFILL);
export const createRefill = (data, headers) => api.create(url.REFILL, data, headers);

export const updateRefill = (id, data, headers) => {
  return api.create(`${url.UPDATE_REFILL}/${id}`, data, headers);
};

export const deleteRefill = (id, headers) => api.create(`${url.DELETE_REFILL}/${id}`, {}, headers);

export const getAllAssignRefill = () => api.get(url.ASSIGN_REFILL);
export const createAssignRefill = (data, headers) => api.create(url.ASSIGN_REFILL, data, headers);

export const updateAssignRefill = (id, data, headers) => {
  return api.create(`${url.UPDATE_ASSIGN_REFILL}/${id}`, data, headers);
};

export const deleteAssignRefill = (id, headers) => api.create(`${url.DELETE_ASSIGN_REFILL}/${id}`, {}, headers);

export const getAllCleaningItem = () => api.get(url.CLEANING_ITEMS);
export const createCleaningItem = (data, headers) => api.create(url.CLEANING_ITEMS, data, headers);

export const updateCleaningItem = (id, data, headers) => {
  return api.create(`${url.UPDATE_CLEANING_ITEMS}/${id}`, data, headers);
};

export const deleteCleaningItem = (id, headers) => api.create(`${url.DELETE_CLEANING_ITEMS}/${id}`, {}, headers);

export const getAllAssignCleaning = () => api.get(url.ASSIGN_CLEANING);
export const createAssignCleaning = (data, headers) => api.create(url.ASSIGN_CLEANING, data, headers);

export const updateAssignCleaning = (id, data, headers) => {
  return api.create(`${url.UPDATE_ASSIGN_CLEANING}/${id}`, data, headers);
};

export const deleteAssignCleaning = (id, headers) => api.create(`${url.DELETE_ASSIGN_CLEANING}/${id}`, {}, headers);

export const getAllUsers = () => api.get(url.GET_ALL_USER);
export const createUsers = (data, headers) => api.create(url.CREATE_USER, data, headers);

export const updateUsers = (id, data, headers) => {
  return api.create(`${url.UPDATE_USER}/${id}`, data, headers);
};

export const deleteUsers = (id, headers) => api.create(`${url.DELETE_USER}/${id}`, {}, headers);
export const invalidateAllUserSessions = (headers) => api.create(url.INVALIDATE_ALL_USER_SESSIONS, {}, headers);

export const getAllRoles = () => api.get(url.ROLE);

export const getAllCleaner = () => api.get(url.CLEANER);
export const createCleaner = (data, headers) => api.create(url.CLEANER, data, headers);
export const deleteCleaner = (id, headers) => api.create(`${url.CLEANER_DELETE}/${id}`, {}, headers);

export const updateCleaner = (id, data, headers) => {
  return api.create(`${url.CLEANER_UPDATE}/${id}`, data, headers);
};

export const getAllSpecialCleaner = () => api.get(url.SPECIAL_CLEANER);
export const createSpecialCleaner = (data, headers) => api.create(url.SPECIAL_CLEANER, data, headers);
export const deleteSpecialCleaner = (id, headers) => api.create(`${url.SPECIAL_CLEANER_DELETE}/${id}`, {}, headers);

export const updateSpecialCleaner = (id, data, headers) => {
  return api.create(`${url.SPECIAL_CLEANER_UPDATE}/${id}`, data, headers);
};

export const getAllCleaningReport = (queryParams) =>
  api.get(
    `${url.GET_CLEANINGREPORT}?page=${queryParams.page}&limit=${queryParams.limit}&bnb=${queryParams.bnb}&startDate=${queryParams.startDate}&endDate=${queryParams.endDate}&cleanerName=${queryParams.cleanerName}&quickFilter=${queryParams.quickFilter || ''}`
  );

export const getAllCleaningAverages = () => api.get(url.GET_AVERAGES);

export const deleteCleanerReport = (id, headers) => api.create(`${url.CLEANER_REPORT_DELETE}/${id}`, {}, headers);

export const deleteRefillRequest = (id, headers) => api.create(`${url.DELETE_REFILL_REQUEST}/${id}`, {}, headers);

export const deleteExtraCleaningRequest = (id, headers) =>
  api.create(`${url.DELETE_EXTRA_CLEANING_REQUEST}/${id}`, {}, headers);

export const getAllLuggage = () => api.get(url.LUGGAGE);
export const createLuggage = (data, headers) => api.create(url.LUGGAGE, data, headers);
export const deleteLuggage = (id, headers) => api.create(`${url.DELETE_LUGGAGE}/${id}`, {}, headers);

export const updateLuggage = (id, data, headers) => {
  return api.create(`${url.UPDATE_LUGGAGE}/${id}`, data, headers);
};

export const getBnBData = (id) => api.get(`${url.GET_BNB_DATA}/${id}`);

export const getAllLuggageLogs = () => api.get(url.LUGGAGE_LOGS);

export const getQuestions = (bnb, city) => api.get(`${url.QUESTIONS}/${bnb}?city=${city}`);

export const getLuggageDoorList = () => api.get(url.GET_LUGGAGE_DOORLIST);

export const createLuggageDoorList = (data, headers) => api.create(url.CREATE_LUGGAGE_DOORLIST, data, headers);

export const updateLuggageDoorlist = (id, data, headers) => {
  return api.create(`${url.UPDATE_LUGGAGE_DOORLIST}/${id}`, data, headers);
};
export const deleteLuggageDoor = (id, headers) => api.create(`${url.DEL_LUGGAGE_DOORLIST}/${id}`, {}, headers);

export const getParking = () => api.get(url.GET_PARKING);

export const createParking = (data, headers) => api.create(url.CREATE_PARKING, data, headers);

export const updateParking = (id, data, headers) => {
  return api.create(`${url.UPDATE_PARKING}/${id}`, data, headers);
};
export const deleteParking = (id, headers) => api.create(`${url.DEL_PARKING}/${id}`, {}, headers);

export const getAllGarage = () => api.get(url.GARAGE);
export const createGarage = (data, headers) => api.create(url.GARAGE, data, headers);
export const deleteGarage = (id, headers) => api.create(`${url.DELETE_GARAGE}/${id}`, {}, headers);

export const updateGarage = (id, data, headers) => {
  return api.create(`${url.UPDATE_GARAGE}/${id}`, data, headers);
};

export const getPrivateParking = () => api.get(url.GET_PRIVATE_PARKING);

export const createPrivateParking = (data, headers) => api.create(url.CREATE_PRIVATE_PARKING, data, headers);

export const updatePrivateParking = (id, data, headers) => {
  return api.create(`${url.UPDATE_PRIVATE_PARKING}/${id}`, data, headers);
};
export const deletePrivateParking = (id, headers) => api.create(`${url.DEL_PRIVATE_PARKING}/${id}`, {}, headers);

export const getAllConversations = (page) => api.get(`${url.GET_CONVERSATION}?page=${page}&limit=100`);
export const searchConversations = (text) => api.get(`${url.SEARCH_CONVERSATION}?text=${text}`);

export const updateUnreadCount = (id) => api.get(`${url.UPDATE_UNREAD_COUNT}/${id}`);
export const updateLastSender = (id) => api.get(`${url.UPDATE_LAST_SENDER}/${id}`);

export const getMessages = (id) => api.get(`${url.GET_MESSAGES}/${id}`);
export const sendMessage = (data, headers) => api.create(url.GET_MESSAGES, data, headers);
export const checkWhatsAppNumberStatus = (data, headers) => api.create(url.CHECK_WHATSAPP_NUMBER, data, headers);

export const getRefillMaintanceExtraCleaning = (id) => api.get(`${url.GET_REFILL_MAINTANCE_EXTRA_CLEANING}/${id}`);
export const updateProcessBookings = (id, data) => api.create(`${url.UPDATE_PROCESS_BOOKINGS}/${id}`, data);

export const deleteBNB = (id) => api.get(`${url.DELETE_BNB_DATA}/${id}`);

export const updateCleaningReport = (id, data, headers) => {
  return api.create(`${url.UPDATE_CLEANINGREPORT}/${id}`, data, headers);
};

export const chatGpt = (data, headers) => api.create(url.OPEN_AI, data, headers);

export const createTrashMap = (data, headers) => api.create(url.TRASH_MAP, data, headers);
export const getTrashMap = () => api.get(url.TRASH_MAP);

export const getAllTrashItem = () => api.get(url.TRASH_ITEMS);
export const createTrashItem = (data, headers) => api.create(url.TRASH_ITEMS, data, headers);

export const updateTrashItem = (id, data, headers) => {
  return api.create(`${url.UPDATE_TRASH_ITEMS}/${id}`, data, headers);
};

export const deleteTrashItem = (id, headers) => api.create(`${url.DELETE_TRASH_ITEMS}/${id}`, {}, headers);

export const getAllTrashDays = () => api.get(url.TRASH_DAYS);
export const createTrashDays = (data, headers) => api.create(url.TRASH_DAYS, data, headers);

export const updateTrashDays = (id, data, headers) => {
  return api.create(`${url.UPDATE_TRASH_DAYS}/${id}`, data, headers);
};

export const deleteTrashDays = (id, headers) => api.create(`${url.DELETE_TRASH_DAYS}/${id}`, {}, headers);

export const bnbDetail = () => api.get(url.BNB_DETAIL);

export const getDoorSetting = () => api.get(url.DOOR_SETTING);
export const createDooSetting = (data, headers) => api.create(url.DOOR_SETTING, data, headers);

export const getAllRepairMan = () => api.get(url.REPAIRMAN);
export const createRepairMan = (data, headers) => api.create(url.REPAIRMAN, data, headers);
export const deleteRepairMan = (id, headers) => api.create(`${url.REPAIRMAN_DELETE}/${id}`, {}, headers);

export const updateRepairMan = (id, data, headers) => {
  return api.create(`${url.REPAIRMAN_UPDATE}/${id}`, data, headers);
};

export const sendCleanerMessage = () => api.get(url.CLEANER_MESSAGE);

export const sendCleanerMessageToday = () => api.get(url.CLEANER_MESSAGE_TODAY);
export const sendCleanerMessageCalender = () => api.get(url.CLEANER_MESSAGE_CALENDER);
export const sendCleanerMessageTomorrow = () => api.get(url.CLEANER_MESSAGE_TOMORROW);

export const getShellySettings = () => api.get(url.SHELLY_SETTING);

export const createShellySettings = (data, headers) => api.create(url.SHELLY_SETTING, data, headers);

export const getDoorScripts = () => api.get(url.DOOR_SCRIPT);

export const createDoorScript = (data, headers) => api.create(url.DOOR_SCRIPT, data, headers);

export const getSmartThingsSettings = () => api.get(url.SMART_THINGS_SETTINGS);

export const createSmartThingsSettings = (data, headers) => api.create(url.SMART_THINGS_SETTINGS, data, headers);

export const fetchSmartThingsDevices = () => api.get(url.SMART_THINGS_DEVICES);
export const getAllSmartThingsDevices = () => api.get(url.GET_ALL_SMART_THINGS_DEVICES);

export const getSmartHomeRoom = () => api.get(url.GET_SMART_HOME_ROOM);
export const getSmartHomeRoomByBnB = (data, headers) => api.create(url.GET_SMART_HOME_ROOM_BY_BNB, data, headers);
export const createSmartHomeRoom = (data, headers) => api.create(url.CREATE_SMART_HOME_ROOM, data, headers);

export const updateSmartHomeRoom = (id, data, headers) => {
  return api.create(`${url.UPDATE_SMART_HOME_ROOM}/${id}`, data, headers);
};
export const deleteSmartHomeRoom = (id, headers) => api.create(`${url.DEL_SMART_HOME_ROOM}/${id}`, headers);

export const createSmartHomeDevice = (data, headers) => api.create(url.CREATE_SMART_HOME_DEVICE, data, headers);

export const getSmartHomeDeviceByBNB = (bnb) => api.get(`${url.GET_SMART_HOME_DEVICE_BY_BNB}/${bnb}`);
export const deleteSmartHomeDevices = (id, headers) => api.create(`${url.DEL_SMART_HOME_DEVICES}/${id}`, headers);

export const getSmartHomeDeviceByBNBWithAccessToken = (bnb) =>
  api.get(`${url.GET_SMART_HOME_DEVICE_BY_BNB_WITH_ACCESS_TOKEN}/${bnb}`);

export const updateSmartHomeDevices = (id, data) => {
  return api.create(`${url.UPDATE_SMART_HOME_DEVICES}/${id}`, data);
};
export const getCityWiseBnB = () => api.get(url.CITY_WISE_BNB);

export const updateHomeDeviceStatus = (id, data) => {
  return api.create(`${url.UPDATE_SMART_HOME_DEVICE_STATUS}/${id}`, data);
};

export const smartHomeControls = (data) => api.create(url.SMART_HOME_CONTROLS, data);

export const getChatSettings = () => api.get(url.CHAT_SETTING);

export const createChatSettings = (data, headers) => api.create(url.CHAT_SETTING, data, headers);

export const getChatPresetMessage = () => api.get(url.CHAT_PRESET_MESSAGE);

export const createChatPresetMessage = (data, headers) => api.create(url.CHAT_PRESET_MESSAGE, data, headers);

export const checkInCheckOutCount = () => api.get(url.CHECK_IN_CHECK_OUT_COUNT);

export const getLastBnBCleanigAmount = () => api.get(url.GET_LAST_BNB_CLEANING_AMOUNT);

export const createExtraCleaningRequest = (data) => api.create(url.CREATE_EXTRA_CLEANING_REQUEST, data);

// export const getAllContractor = () => api.get(url.CONTRACTOR);
export const createContractor = (data, headers) => api.create(url.CONTRACTOR, data, headers);
export const deleteContractor = (id, headers) => api.create(`${url.CONTRACTOR_DELETE}/${id}`, {}, headers);

export const updateContractor = (id, data, headers) => {
  return api.create(`${url.CONTRACTOR_UPDATE}/${id}`, data, headers);
};

export const getAllContractor = (data, headers) => {
  return api.create(`${url.CONTRACTS}`, data, headers);
};
export const updateContract = (id, data) => {
  return api.update(`${url.UPDATE_CONTRACT_DETAILS}/${id}`, data);
};
export const adminCorrectContract = (id, data, headers) => {
  return api.create(`${url.ADMIN_CORRECT_CONTRACT}/${id}`, data, headers);
};

export const updateProperty = (id, data, headers) => {
  return api.create(`${url.UPDATE_PROPERTY}/${id}`, data, headers);
};

export const getContractProperties = (id) => api.get(`${url.CONTRACT_PROPERTIES}/${id}`);

export const getAllContractTemplates = () => api.get(url.CONTRACT);

export const deleteContractTemplates = (id, headers) => api.create(`${url.DELETE_CONTRACT}/${id}`, {}, headers);

export const createContractTemplates = (data, headers) => api.create(url.CONTRACT, data, headers);
export const updateContractTemplates = (id, data, headers) => {
  return api.create(`${url.UPDATE_CONTRACT}/${id}`, data, headers);
};
export const setDefaultContractTemplate = (id, headers) => api.create(`${url.DEFAULT_CONTRACT_TEMPLATE}/${id}`, {}, headers);
export const getContractSettingsdata = () => api.get(url.GET_CONTRACT_SETTINGS);

export const updateContractSettings = (data, headers) => {
  return api.create(url.UPDATE_CONTRACT_SETTINGS, data, headers);
};

export const getTwilioSettings = () => api.get(url.TWILIO_SETTING);

export const createTwilioSettings = (data, headers) => api.create(url.TWILIO_SETTING, data, headers);

export const getAllTwilioNumbers = () => api.get(url.TWILIO_NUMBER);
export const createTwilioNumbers = (data, headers) => api.create(url.TWILIO_NUMBER, data, headers);

export const updateTwilioNumbers = (id, data, headers) => {
  return api.create(`${url.UPDATE_TWILIO_NUMBER}/${id}`, data, headers);
};

export const deleteTwilioNumbers = (id, headers) => api.create(`${url.DELETE_TWILIO_NUMBER}/${id}`, {}, headers);

export const testTwilioNumbers = (data, headers) => api.create(url.TEST_TWILIO_NUMBER, data, headers);

export const createTtlockSettings = (data, headers) => api.create(url.TTLOCK_SETTINGS, data, headers);
export const getTtlockSettings = () => api.get(url.TTLOCK_SETTINGS);

export const getTTLockDevices = () => api.get(url.TTLOCK_DEVICES);

export const getMonthlyStatement = (month, year) => api.get(`${url.GET_MONTHLY_STATMENT}?month=${month}&year=${year}`);

export const getCleanerOverview = () => api.get(url.CLEANER_OVERVIEW);

export const getDatabaseCollections = () => api.get(url.DATABASE_COLLECTIONS);
export const getDatabaseCollectionDocuments = (collection, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  const queryString = query.toString();
  const path = `${url.DATABASE_COLLECTIONS}/${encodeURIComponent(collection)}${queryString ? `?${queryString}` : ''}`;
  return api.get(path);
};
